import { render } from "./PimProductsOverviewLegend.vue?vue&type=template&id=44b29c3b&scoped=true&ts=true"
import script from "./PimProductsOverviewLegend.vue?vue&type=script&lang=ts"
export * from "./PimProductsOverviewLegend.vue?vue&type=script&lang=ts"

import "./PimProductsOverviewLegend.vue?vue&type=style&index=0&id=44b29c3b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b29c3b"]])

export default __exports__